// **** horários sem colaboradores ****
// **** p_horarios.jsx ****
// **** autor: Walcledson de Paula ****
// **** 08/11/24 | 22h12 ****



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiDoorClosedLock, mdiStoreSettingsOutline } from '@mdi/js'; // novo // alterar
import apiaxios from '../../../../../../Services/apiaxios.js';
import { decrypt } from '../../../../../../Services/cryptoUtils.js';
import handleApiError from '../../../../../../Services/apiErrorHandler.js';
import { p_getUserData } from '../../../../../../Services/p_userutils.js';
import { AutoLogout } from '../../../../../../Services/autologout.js';
// import Select from 'react-select';
import { Button, Form } from 'react-bootstrap';

import Menu from '../../../../Components/Menu/p_menu.jsx';
import Footer from "../../../../../AgendexCliente/components/Footer/footer.jsx";
import './p_horarios.css';

const Horarios = () => {
    // verifica se token está ok
//     const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");

    // verifica se token está ok
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId); // id_usuario logado 23/9/24w

    const [loading, setLoading] = useState(false);
    const [horarios, setHorarios] = useState([]);
    const [intervalos, setIntervalos] = useState([]);
    const [tempoAgendaMinutos, setTempoAgendaMinutos] = useState(60);
    const [nenhumDiaHorarioEncontrado, setNenhumDiaHorarioEncontrado] = useState(false);
    const [nenhumDiaHorarioFuncionamentoEncontrado, setNenhumDiaHorarioFuncionamentoEncontrado] = useState([]);
    const [excecoes, setExcecoes] = useState([]);
    const [nenhumaExcecaoEncontrada, setNenhumaExcecaoEncontrada] = useState([]);
    const diasSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
    const navigate = useNavigate();

    const [diasFuncionamento, setDiasFuncionamento] = useState([
        { id: 1, dia: 'Domingo',        atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 2, dia: 'Segunda-feira',  atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 3, dia: 'Terça-feira',    atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 4, dia: 'Quarta-feira',   atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 5, dia: 'Quinta-feira',   atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 6, dia: 'Sexta-feira',    atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
        { id: 7, dia: 'Sábado',         atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] }
    ]);
    
    useEffect(() => {
//         loadColaboradores();
        loadTempoAgendaMinutos();

    }, [userId]);

    // const loadColaboradores = async () => {
    //     if (userId) {
    //         try {
    //             const empresaColaboradores = await fetchColaboradores(userId);
    //             setColaboradores(empresaColaboradores);
    //         } catch (error) {
    //             console.error('Erro ao buscar colaboradores:', error);
    //         }
    //     }
    // };

    const loadTempoAgendaMinutos = async () => {
        if (userId) {
            try {
                setLoading(true);
                const empresaTempoAgendaMinutos = await fetchTempoAgendaMinutos(userId);
                setTempoAgendaMinutos(empresaTempoAgendaMinutos);
            } catch (error) {
                console.error('Erro ao buscar intervalo da agenda:', error);
            } finally {
                setLoading(false);
            }
        }
    };

//     const fetchColaboradores = async (id_empresa) => {
//         try {
//             setLoading(true);
// //             const colaboradoresResponse = await apiaxios.get(`/empresa/colaboradorWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`); // modificada pela linha abaixo 20/10/24w13h30
//             const colaboradoresResponse = await apiaxios.get(`/colaborador/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
//             if (colaboradoresResponse.status === 200 && colaboradoresResponse.data.length > 0) {
//                 return colaboradoresResponse.data;
//             } else {
//                 setNenhumColaboradorEncontrado(true);
//                 return [];
//             }
//         } catch (error) {
//             handleApiError(error);
//             return [];
//         } finally {
//             setLoading(false);
//         }

//     };

    const fetchTempoAgendaMinutos = async (id_empresa) => {
        try {
            setLoading(true);
            const tempoAgendaMinutosResponse = await apiaxios.get(`/configuracao/IntervaloAgendaWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (tempoAgendaMinutosResponse.status === 200 && tempoAgendaMinutosResponse.data.length > 0) {
                return tempoAgendaMinutosResponse.data;
            } else {
                setNenhumDiaHorarioEncontrado(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        // if (selectedColaborador) {
            loadExceccoes();
            loadDiasHorariosFuncionamento();
        // };

    }, []);
//     }, [selectedColaborador]);

    // Carregar dias de exceções
    const loadExceccoes = async () => {
        if (userId) {
            try {
                const empresaExcecoes = await fetchExcecoes(userId);
                setExcecoes(empresaExcecoes);
            } catch (error) {
                console.error('Erro ao buscar dias de feriados/exceções:', error);
            }
        }
    };

    // Carregar dias e horários de funcionamento
    const loadDiasHorariosFuncionamento = async () => {
        if (userId) {
            try {
                const empresaDiasHorariosFuncionamento = await fetchDiasHorariosFuncionamento(userId);
                setHorarios(empresaDiasHorariosFuncionamento);
            } catch (error) {
                console.error('Erro ao buscar dias/horários de funcionamento:', error);
            }
        }
    };

    const fetchExcecoes = async (id_empresa) => {
        try {
            setLoading(true);
            const excecoesResponse = await apiaxios.get(`/empresa/QTExcecoesWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (excecoesResponse.status === 200 && excecoesResponse.data.length > 0) {
                return excecoesResponse.data;
            } else {
                setNenhumaExcecaoEncontrada(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    // const fetchDiasHorariosFuncionamento = async (id_empresa, id_colaborador) => {
    const fetchDiasHorariosFuncionamento = async (id_empresa) => {
        setDiasFuncionamento([
            { id: 1, dia: 'Domingo',        atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 2, dia: 'Segunda-feira',  atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 3, dia: 'Terça-feira',    atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 4, dia: 'Quarta-feira',   atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 5, dia: 'Quinta-feira',   atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 6, dia: 'Sexta-feira',    atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] },
            { id: 7, dia: 'Sábado',         atendimento: false, horarios: [{ tipo: 'horainicio', value: '00:00' }, { tipo: 'horafim', value: '00:00' }], intervalos: [{ tipo: 'intervaloinicio', value: '00:00' }, { tipo: 'intervalofim', value: '00:00' }] }
        ]);
    
        try {
            setLoading(true);
            const diasHorariosFuncionamentoResponse = await apiaxios.get(`/empresa/DiasFuncionamentoSemColaboradorWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            
            if (diasHorariosFuncionamentoResponse.status === 200 && diasHorariosFuncionamentoResponse.data.length > 0) {
                const formattedData = diasHorariosFuncionamentoResponse.data.map(dia => ({
                    AGE_DIASEMANA: dia.AGE_DIASEMANA, // Assume-se que seja o id correspondente ao dia da semana
                    AGE_HORAINICIAL: dia.AGE_HORAINICIAL.slice(0, 5),
                    AGE_HORAFINAL: dia.AGE_HORAFINAL.slice(0, 5),
                    AGE_INTERVALOINICIAL: dia.AGE_INTERVALOINICIAL.slice(0, 5),
                    AGE_INTERVALOFINAL: dia.AGE_INTERVALOFINAL.slice(0, 5)
                }));
                // console.log ('formattedData ', formattedData);
    
                updateDiasFuncionamento(formattedData);
            } else {
                setNenhumDiaHorarioFuncionamentoEncontrado(true);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
    
    const updateDiasFuncionamento = (dados) => {
        setDiasFuncionamento(prevDias =>
            prevDias.map(dia => {
                // Procurando por AGE_DIASEMANA em vez de 'id'
                const dado = dados.find(d => d.AGE_DIASEMANA === dia.id);
                if (dado) {
                    const horarios = [
                        { tipo: 'horainicio', value: dado.AGE_HORAINICIAL },
                        { tipo: 'horafim', value: dado.AGE_HORAFINAL }
                    ];
                    const intervalos = [
                        { tipo: 'intervaloinicio', value: dado.AGE_INTERVALOINICIAL },
                        { tipo: 'intervalofim', value: dado.AGE_INTERVALOFINAL }
                    ];
                    const horariosCompletosZero = horarios.every(h => h.value === '00:00');
    
                    // Atualiza atendimento e horários com os valores do backend
                    return { ...dia, atendimento: !horariosCompletosZero, horarios, intervalos };
                } else {
                    // Se não houver dado correspondente, retorna valores padrão
                    return { ...dia, atendimento: false, horarios: [], intervalos: [] };
                }
            })
        );
    };

    const handleCheckboxChange = (id) => {
        setDiasFuncionamento(prevDias =>
            prevDias.map(dia =>
                dia.id === id
                    ? { ...dia, atendimento: !dia.atendimento }
                    : dia
            )
        );
    };

    const handleHorarioChange = (diaId, tipoHorario, novoValor) => {
        setDiasFuncionamento(prevState => 
            prevState.map(dia => {
                if (dia.id === diaId) {
                    return {
                        ...dia,
                        horarios: dia.horarios.map(horario =>
                            horario.tipo === tipoHorario ? { ...horario, value: novoValor } : horario
                        ),
                        intervalos: dia.intervalos.map(intervalo =>
                            intervalo.tipo === tipoHorario ? { ...intervalo, value: novoValor } : intervalo
                        )
                    };
                }
                return dia;
            })
        );
    };
    
//     const handleSave = (selectedColaborador) => {
    const handleSave = () => {
        Swal.fire({
            title: 'Confirmação',
            text: `Confirma as alterações dos dias/horários de funcionamento ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, salvar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                saveHorarios();
            }
        });
    };
        
    // Função para salvar os horários (update or insert)
    const saveHorarios = () => {
        const DiasHorarios = diasFuncionamento.map(dia => ({
            diasemana:          dia.id,
            horainicial:        dia.horarios.find(h => h.tipo === 'horainicio')?.value || '00:00',
            horafinal:          dia.horarios.find(h => h.tipo === 'horafim')?.value || '00:00',
            intervaloinicial:   dia.intervalos.find(i => i.tipo === 'intervaloinicio')?.value || '00:00',
            intervalofinal:     dia.intervalos.find(i => i.tipo === 'intervalofim')?.value || '00:00'
        }));
        
        const payload = { DiasHorarios };
        
        const headers = {
            params: {
                id_empresa: userId,
                id_usuario: userId,
                token: tokenASW
            }
        };
    
        apiaxios.post('/empresa/DiasFuncionamentoSemColaboradorWeb', payload, headers)
            .then(response => {
                Swal.fire('Informação', 'Horários salvos com sucesso!', 'success');
            })
            .catch(error => {
                console.error('Erro ao salvar horários:', error);
            });
    };
    
    const ConfigurarHorarios = ({ diasFuncionamento, setDiasFuncionamento }) => {
        useEffect(() => {
            // Evita alterar o estado se ele já estiver correto
            const diasJaConfigurados = diasFuncionamento.every((dia, index) => {
              return dia !== undefined && dia.id === index + 1;
            });
          
            if (!diasJaConfigurados) {
              setDiasFuncionamento(diasFuncionamento.map((dia, index) => ({
                ...dia,
                id: index + 1,
                // outras propriedades que você queira definir
              })));
            }
        }, [diasFuncionamento]);

        const handleRegras = () => {
            navigate('/app/prestador/empresa/regras');
        };
    
        const handleFeriados = () => {
            navigate('/app/prestador/empresa/regras/feriados');
        };



        return (
            <div className="p_colaboradores_horarios">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="regras" />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="container-fluid">
                                <h1 className="text-center">Dias/Horários de Funcionamento</h1>
                                <hr />
                                <div className="text-right">
                                    <button type='button' className="btn btn-info m-2" onClick={() => handleFeriados()}>
                                        <Icon path={mdiDoorClosedLock } size={1} className="me-2"/>Feriados
                                    </button>
                                    <button className="btn btn-info m-2" onClick={() => handleRegras()}>
                                        <Icon path={mdiStoreSettingsOutline } size={1} className="me-2"/>Regras
                                    </button>
                                </div>

                                {loading && <div className="loading-spinner-container">
                                    <Oval
                                        height={50}
                                        width={50}
                                        color="#007bff"
                                        ariaLabel="oval-loading"
                                        secondaryColor="#007bff"
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                    />
                                </div>}

                                <div className="form-group">

                                    {/* {selectedColaborador && ( */}
                                        <>
                                            <Form.Group>
                                                <Form.Label>Configurar Horários</Form.Label>
                                                {diasFuncionamento.map((dia) => (
                                                    <div key={dia.id}>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={dia.atendimento}
                                                                onChange={() => handleCheckboxChange(dia.id)}
                                                            />
                                                            {dia.dia}
                                                        </label>
                                                        {dia.atendimento && (
                                                            <div>
                                                                <label className='ml-10'>
                                                                    Hora Início:
                                                                    <input
                                                                        className="form-control"
                                                                        type="time"
                                                                        value={dia.horarios.find(h => h.tipo === 'horainicio')?.value || ''}
                                                                        onChange={(e) => handleHorarioChange(dia.id, 'horainicio', e.target.value)}
                                                                    />
                                                                </label>

                                                                <label className='ml-10'>
                                                                    Hora Fim:
                                                                    <input
                                                                        className="form-control"
                                                                        type="time"
                                                                        value={dia.horarios.find(h => h.tipo === 'horafim')?.value || ''}
                                                                        onChange={(e) => handleHorarioChange(dia.id, 'horafim', e.target.value)}
                                                                    />
                                                                </label>

                                                                <label className='ml-10'>
                                                                    Intervalo Início:
                                                                    <input
                                                                        className="form-control" // Adicione uma classe para estilizar
                                                                        type="time"
                                                                        value={dia.intervalos.find(h => h.tipo === 'intervaloinicio')?.value || ''}
                                                                        onChange={(e) => handleHorarioChange(dia.id, 'intervaloinicio', e.target.value)}
                                                                        />
                                                                </label>
                                                                <label className='ml-10'>
                                                                    Intervalo Fim:
                                                                    <input
                                                                        className="form-control" // Adicione uma classe para estilizar
                                                                        type="time"
                                                                        value={dia.intervalos.find(h => h.tipo === 'intervalofim')?.value || ''}
                                                                        onChange={(e) => handleHorarioChange(dia.id, 'intervalofim', e.target.value)}
                                                                    />
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </Form.Group>

                                            <div className="text-center">
                                                <Button className="m-4" variant="primary" onClick={handleSave}>
                                                    Salvar Horários
                                                </Button>
                                            </div>
                                        </>
                                    {/* )}   */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    };

    return (
        <Form>
            <ConfigurarHorarios diasFuncionamento={diasFuncionamento} setDiasFuncionamento={setDiasFuncionamento} />
        </Form>
    );
};

export default Horarios;